module.exports = __webpack_public_path__ + "static/mobile_flowers-35326f2693ccdfeae26490781ab1045b.png";